import { SEMANTIC_TOKENS } from 'src/app/core/theming/theme-token-catalog';

// Gedeelde animatieduur van het thema (Theme › Elements › Layout › Animatieduur, --layout-motion-duration).
// Eén bron voor de paginawissels (tab in/uit, details <-> edit). CSS-transities gebruiken de variabele direct
// (var(--layout-motion-duration)); Angular-animaties kunnen geen CSS-variabelen lezen en krijgen de waarde via
// motionDuration_read als animatie-param.
const __motionDurationToken = SEMANTIC_TOKENS['layout.motion.duration'];

export const MOTION_DURATION_DEFAULT = __motionDurationToken.default;

export function duration_isValid(value: string): boolean {
    return /^\d+(\.\d+)?(ms|s)$/.test(value);
}

// Leest --layout-motion-duration op `element` (standaard de pagina-root, waar het actieve thema staat). Ongeldig
// of leeg → de catalogus-standaard.
export function motionDuration_read(element: Element | null = typeof document !== 'undefined' ? document.documentElement : null): string {
    if (!element) return MOTION_DURATION_DEFAULT;
    const __value = getComputedStyle(element).getPropertyValue(__motionDurationToken.cssVar).trim();
    return duration_isValid(__value) ? __value : MOTION_DURATION_DEFAULT;
}
